import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-demo-booking',
  templateUrl: './demo-booking.component.html',
  styleUrls: ['./demo-booking.component.scss']
})
export class DemoBookingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
